import React, { PropsWithChildren, useState } from 'react';
import { useFeatureServices } from '../hooks/use-feature-services';
import { QSGContext } from '../hooks/use-qsg-context';
import { translation } from '../lang/translation';
import { LangType } from '../typings/lang';
import { QSGContextType } from '../typings/qsg-app';

export const QSGContextProvider = (props: PropsWithChildren) => {
  const { 'locale-service': localeService } = useFeatureServices();
  const localeLang = localeService.language as LangType;

  const [lang, setLang] = useState<LangType>(localeLang);

  const translationHandler = (key: string): string => {
    return translation(lang, key);
  };

  const QSGContextValue: QSGContextType = {
    translationHandler,
    lang: {
      value: lang,
      set: setLang,
    },
  };

  return (
    <QSGContext.Provider value={QSGContextValue}>
      {props.children}
    </QSGContext.Provider>
  );
};
